
import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
import { iPointsCard } from '@/interface/purchase';
import { setIOSId } from '@/api/coinManaging';
import { toast } from '@/utils/common';

@Component({
  filters: {
    priceFormat(price: number) {
      return (price / 100).toFixed(2);
    },
  },
})
export default class CloudItem extends Vue {
  @Prop({ type: Object, required: true }) info!: iPointsCard;
  @Prop({ default: false }) isShowPID!: boolean;
  hover: boolean = false;
  isUpdate: boolean = false;
  proName: string = '';
  id: number | null = null;
  @Emit('deleteCloudRecharge')
  deleteCloudRecharge() {
    return this.info;
  }
  @Emit('edit')
  edit() {
    return this.info;
  }
}
